// Mounts the TanStack Query client for the whole app.
//
// `@tanstack/react-query` was installed but never wired in — this provider is
// the missing piece. It wraps the app ALONGSIDE the existing Redux <Provider>
// (additive migration), so nothing in the current screens breaks.
//
// (React Query Devtools are intentionally not imported — the devtools package
// isn't a dependency, and a dynamic import of a missing module would break the
// CRA production build. Add `@tanstack/react-query-devtools` and wire it here
// if/when desired.)

import React from "react";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./queryClient";

export const ApiProvider = ({ children, client = queryClient }) => (
  <QueryClientProvider client={client}>{children}</QueryClientProvider>
);

export default ApiProvider;
